import { render, staticRenderFns } from "./distributionCountDown.vue?vue&type=template&id=6ad961d1&scoped=true&"
import script from "./distributionCountDown.vue?vue&type=script&lang=js&"
export * from "./distributionCountDown.vue?vue&type=script&lang=js&"
import style0 from "./distributionCountDown.vue?vue&type=style&index=0&id=6ad961d1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad961d1",
  null
  
)

export default component.exports